// DialogContext.js
import {  createContext, useContext, useRef, useState, useEffect } from 'react';
import constants from '../constants';
import styles from './loadingspinner.module.css';

// This provider wraps the global message dialog with the "isLoading" spinner for API calls.
// These are bundled as whenever an API call is made, it should display the loading spinner
// while it is happening, and then if an error occurs we should show it in the dialog
const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const dialogRef = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [dialogTitle, setDialogTitle] = useState();
  const [dialogCode, setDialogCode] = useState();
  const [dialogMessage, setDialogMessage] = useState();
  const [isError, setIsError] = useState(false);

  const setDialog = ({title, code, message, isError}) => {

    let newMessage;
    if (message && message.hasOwnProperty('message')){
      newMessage = message.message;
    }
 
    if (message && message.errors){
      const keys = Object.keys(message.errors);
      newMessage = message.errors[keys[1]][0];
    }

    if (typeof message == "string") {
      newMessage = message;
    }
    
    setDialogTitle(title);
    setDialogCode(code);
    setDialogMessage(newMessage);
    setIsError(isError);
  };

  const closeDialog = (e) => {
    setDialogTitle();
    setDialogCode();
    setDialogMessage();
    setIsError(isError);
    dialogRef.current?.close();
  };

  const LoadingSpinner = ({size}) => {
    size = size ? size : '40';
    return (
      <div style={{display:'flex',justifyContent:'center'}}>
        <div style={{height:`${size}px`, width:`${size}px`}} className={styles.Spinner}></div>
      </div>
    )
  };

  useEffect(() => {
    if (dialogTitle && dialogCode){
      // Show the dialog after the state has been updated
      dialogRef.current?.show();
      
      // // Close the dialog after 5000ms
      // setTimeout(() => {
      //   closeDialog();
      // }, 5000); // close after 5 seconds
    }
  }, [dialogTitle, dialogCode, isError]);

  return (
    <ApiContext.Provider 
      value={{ 
        dialogRef, 
        setDialog, 
        closeDialog, 
        isLoading, 
        setIsLoading,
        LoadingSpinner,
        dialogTitle,
        setDialogTitle,
        dialogCode,
        setDialogCode,
        dialogMessage,
        setDialogMessage,
        isError,
        setIsError}}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApiProvider = () => useContext(ApiContext);